import {SvelteDialog} from 'root/v-app/rbServices';
import ViewBidMessagesDialog from './ViewBidMessagesDialog.svelte';
import SendBidMessagesDialog from './SendBidMessagesDialog.svelte';
import {loadUpdatedBids} from 'rfp/bid-manager/main/stores/bids-raw';

import noop from 'lodash/noop';


export function SendMessages() {
  return function (selectedBidsReport) {
    return {
      label: 'Send Messages',
      icon: 'question_answer',
      isAvailable: () => {
        let available = selectedBidsReport.user === 'BUYER';
        available = available && !selectedBidsReport.statuses.includes('CREATED');
        available = available && !selectedBidsReport.statuses.includes('BUYER_DRAFT');
        available = available && !selectedBidsReport.statuses.includes('COMPETITIVE_RESPONDED');
        return available;
      },
      action: () => {
        SvelteDialog.show(SendBidMessagesDialog, {bidsIds: selectedBidsReport.bidsIds})
          .then(() => loadUpdatedBids(selectedBidsReport.bidsIds))
          .catch(noop);
      }
    }
  }
}

export function viewMessages(bidId, subjectType, options = {}){
  return SvelteDialog.show(ViewBidMessagesDialog, {...options, bidId, subjectType});
}

